import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MyDatePipe} from './my-date.pipe';


@NgModule({
    declarations: [
        MyDatePipe
    ],
    exports: [
        MyDatePipe
    ],
    imports: [
        CommonModule
    ]
})
export class MyDateModule {
}
